import useComplexState from '@/lib/utils/useComplexState';
import { v4 as generateUuid } from 'uuid';

const useAggregatedLoadingState = (): [
  boolean,
  () => string,
  (loaderId: string) => void,
] => {
  const [loaderIds, setLoaderIds] = useComplexState(new Set<string>());

  const registerLoadStart = (): string => {
    const loaderId = generateUuid();

    setLoaderIds(loaderIds => {
      loaderIds.add(loaderId);
    });

    return loaderId;
  };

  const registerLoadEnd = (loaderId: string): void => {
    setLoaderIds(loaderIds => {
      loaderIds.delete(loaderId);
    });
  };

  const isLoading = loaderIds.size > 0;

  return [isLoading, registerLoadStart, registerLoadEnd];
};

export default useAggregatedLoadingState;
